export default "__VITE_ASSET__fP5S_Omc__"